import { getPersistedRoute } from "@/hooks/use-route-persistance";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/ausgang/",
)({
  beforeLoad: ({ params }) => {
    const persistedRoute = getPersistedRoute(params.company, "receivable");

    console.log("debug", "persistedRoute", persistedRoute);

    if (persistedRoute) {
      throw redirect({ to: persistedRoute, replace: true });
    }

    throw redirect({
      to: "/$company/buchhaltung/ausgang/uploads",
      params: { company: params.company },
      replace: true,
    });
  },
});
